/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterTextImageContentAddPost } from '../fn/text-image-content/api-master-text-image-content-add-post';
import { ApiMasterTextImageContentAddPost$Params } from '../fn/text-image-content/api-master-text-image-content-add-post';
import { apiMasterTextImageContentDeleteGet } from '../fn/text-image-content/api-master-text-image-content-delete-get';
import { ApiMasterTextImageContentDeleteGet$Params } from '../fn/text-image-content/api-master-text-image-content-delete-get';
import { apiMasterTextImageContentEditPost } from '../fn/text-image-content/api-master-text-image-content-edit-post';
import { ApiMasterTextImageContentEditPost$Params } from '../fn/text-image-content/api-master-text-image-content-edit-post';
import { apiMasterTextImageContentGetActiveGet } from '../fn/text-image-content/api-master-text-image-content-get-active-get';
import { ApiMasterTextImageContentGetActiveGet$Params } from '../fn/text-image-content/api-master-text-image-content-get-active-get';
import { apiMasterTextImageContentGetAllGet } from '../fn/text-image-content/api-master-text-image-content-get-all-get';
import { ApiMasterTextImageContentGetAllGet$Params } from '../fn/text-image-content/api-master-text-image-content-get-all-get';
import { apiMasterTextImageContentGetByCriteriaPost } from '../fn/text-image-content/api-master-text-image-content-get-by-criteria-post';
import { ApiMasterTextImageContentGetByCriteriaPost$Params } from '../fn/text-image-content/api-master-text-image-content-get-by-criteria-post';
import { apiMasterTextImageContentGetByIdGet } from '../fn/text-image-content/api-master-text-image-content-get-by-id-get';
import { ApiMasterTextImageContentGetByIdGet$Params } from '../fn/text-image-content/api-master-text-image-content-get-by-id-get';
import { StringApiRespModel } from '../models/string-api-resp-model';
import { TextImageContent } from '../models/text-image-content';
import { TextImageContentApiRespModel } from '../models/text-image-content-api-resp-model';

@Injectable({ providedIn: 'root' })
export class TextImageContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterTextImageContentAddPost()` */
  static readonly ApiMasterTextImageContentAddPostPath = '/api/Master/TextImageContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTextImageContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTextImageContentAddPost$Response(params?: ApiMasterTextImageContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TextImageContentApiRespModel>> {
    return apiMasterTextImageContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTextImageContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTextImageContentAddPost(params?: ApiMasterTextImageContentAddPost$Params, context?: HttpContext): Observable<TextImageContentApiRespModel> {
    return this.apiMasterTextImageContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TextImageContentApiRespModel>): TextImageContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTextImageContentEditPost()` */
  static readonly ApiMasterTextImageContentEditPostPath = '/api/Master/TextImageContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTextImageContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTextImageContentEditPost$Response(params?: ApiMasterTextImageContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TextImageContentApiRespModel>> {
    return apiMasterTextImageContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTextImageContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTextImageContentEditPost(params?: ApiMasterTextImageContentEditPost$Params, context?: HttpContext): Observable<TextImageContentApiRespModel> {
    return this.apiMasterTextImageContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<TextImageContentApiRespModel>): TextImageContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTextImageContentDeleteGet()` */
  static readonly ApiMasterTextImageContentDeleteGetPath = '/api/Master/TextImageContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTextImageContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentDeleteGet$Response(params?: ApiMasterTextImageContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterTextImageContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTextImageContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentDeleteGet(params?: ApiMasterTextImageContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterTextImageContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterTextImageContentGetByIdGet()` */
  static readonly ApiMasterTextImageContentGetByIdGetPath = '/api/Master/TextImageContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTextImageContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentGetByIdGet$Response(params?: ApiMasterTextImageContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TextImageContent>> {
    return apiMasterTextImageContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTextImageContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentGetByIdGet(params?: ApiMasterTextImageContentGetByIdGet$Params, context?: HttpContext): Observable<TextImageContent> {
    return this.apiMasterTextImageContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<TextImageContent>): TextImageContent => r.body)
    );
  }

  /** Path part for operation `apiMasterTextImageContentGetAllGet()` */
  static readonly ApiMasterTextImageContentGetAllGetPath = '/api/Master/TextImageContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTextImageContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentGetAllGet$Response(params?: ApiMasterTextImageContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TextImageContent>>> {
    return apiMasterTextImageContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTextImageContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentGetAllGet(params?: ApiMasterTextImageContentGetAllGet$Params, context?: HttpContext): Observable<Array<TextImageContent>> {
    return this.apiMasterTextImageContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TextImageContent>>): Array<TextImageContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTextImageContentGetActiveGet()` */
  static readonly ApiMasterTextImageContentGetActiveGetPath = '/api/Master/TextImageContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTextImageContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentGetActiveGet$Response(params?: ApiMasterTextImageContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TextImageContent>>> {
    return apiMasterTextImageContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTextImageContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterTextImageContentGetActiveGet(params?: ApiMasterTextImageContentGetActiveGet$Params, context?: HttpContext): Observable<Array<TextImageContent>> {
    return this.apiMasterTextImageContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TextImageContent>>): Array<TextImageContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterTextImageContentGetByCriteriaPost()` */
  static readonly ApiMasterTextImageContentGetByCriteriaPostPath = '/api/Master/TextImageContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterTextImageContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTextImageContentGetByCriteriaPost$Response(params?: ApiMasterTextImageContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TextImageContent>>> {
    return apiMasterTextImageContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterTextImageContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterTextImageContentGetByCriteriaPost(params?: ApiMasterTextImageContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<TextImageContent>> {
    return this.apiMasterTextImageContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TextImageContent>>): Array<TextImageContent> => r.body)
    );
  }

}
